import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/dyVAvYgYjmMy61oy2AaY/locations/e0itrf2vbBE2K5HMnAXh`}
              target="_blank"
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="100%"
                  maxWidth="270px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/dyVAvYgYjmMy61oy2AaY/locations/e0itrf2vbBE2K5HMnAXh`}
              target="_blank"
            >
              <CFView hover mt="5px">
                <CFImage
                  src={orderPickupButton}
                  w="100%"
                  maxWidth="230px"
                  alt="About"
                />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
